import Vue from "vue";
import VueRouter from "vue-router";
import Product from "../views/ProductList.vue";
import ProductDetail from "../views/ProductDetail.vue";
import Cart from "../views/Cart.vue";
import Login from "../views/Auth/Login.vue";
import Signup from "../views/Auth/Signup.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "product",
    component: Product
  },
  {
    path: "/detail",
    name: "productDetail",
    component: ProductDetail
  },
  {
    path: "/cart",
    name: "Cart",
    component: Cart
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;

//https://jasonwatmore.com/post/2018/07/14/vue-vuex-user-registration-and-login-tutorial-example
router.beforeEach((to, from, next) => {
  const publicPages = [
    "/",
    "/detail",
    "/login",
    "/signup",
    "/about123"
  ];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("user");

  if (authRequired && !loggedIn) {
    return next("/login?next=" + to.path);
  }
  next();
});
